import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { createPageUrl } from '../utils/index.ts';
import { User } from '../api/supabaseEntities.js';

export default function AdminLogin() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  console.log('🔍 AdminLogin renderizando...');

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('📝 Tentando fazer login...');
    setIsLoading(true);
    setError('');

    try {
      if (!formData.email || !formData.password) {
        throw new Error('Por favor, preencha todos os campos');
      }

      await User.signIn(formData.email, formData.password);
      
      // Verificar se o usuário tem permissão de admin/support
      const profile = await User.getCurrentProfile();
      if (profile && (profile.role === 'admin' || profile.role === 'support' || profile.role === 'developer')) {
        navigate(createPageUrl('Dashboard'));
      } else {
        await User.signOut();
        throw new Error('Acesso negado. Esta área é restrita à equipe interna.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(error.message || 'Erro ao fazer login. Verifique suas credenciais.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    setError('');
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #1e293b 0%, #7c3aed 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'rgba(30, 41, 59, 0.9)',
        padding: '40px',
        borderRadius: '12px',
        width: '100%',
        maxWidth: '400px',
        color: 'white',
        boxShadow: '0 20px 40px rgba(0,0,0,0.3)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: 'bold', marginBottom: '8px' }}>
            HelpDeskPro
          </h1>
          <p style={{ color: '#94a3b8' }}>
            Área exclusiva para equipe interna
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', color: '#e2e8f0' }}>
              E-mail
            </label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="seu@email.com"
              required
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #475569',
                background: 'rgba(51, 65, 85, 0.5)',
                color: 'white',
                fontSize: '16px'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', color: '#e2e8f0' }}>
              Senha
            </label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleInputChange}
              placeholder="Sua senha"
              required
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid #475569',
                background: 'rgba(51, 65, 85, 0.5)',
                color: 'white',
                fontSize: '16px'
              }}
            />
          </div>

          {error && (
            <div style={{
              padding: '12px',
              marginBottom: '20px',
              background: 'rgba(239, 68, 68, 0.2)',
              border: '1px solid #dc2626',
              borderRadius: '8px',
              color: '#fca5a5',
              fontSize: '14px'
            }}>
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={isLoading}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '8px',
              border: 'none',
              background: '#6366f1',
              color: 'white',
              fontSize: '16px',
              fontWeight: '600',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.7 : 1
            }}
          >
            {isLoading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '24px' }}>
          <p style={{ fontSize: '14px', color: '#94a3b8' }}>
            Acesso apenas para equipe interna.
            <br />
            Se você é cliente, acesse o{' '}
            <a 
              href={createPageUrl('ClientLogin')}
              style={{ color: '#6366f1', textDecoration: 'underline' }}
            >
              Portal do Cliente
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}